import * as React from "react";
const SvgPlaneTakeoff = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 19.898a1 1 0 0 1 0 2H3a1 1 0 1 1 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.828 4.001a2.96 2.96 0 0 1 4.023 1.038 1.98 1.98 0 0 1-.687 2.722L8.148 15.488c-.685.407-1.27.777-1.916.868a3 3 0 0 1-1.555-.195c-.603-.247-1.078-.75-1.642-1.314L.793 12.605a1 1 0 0 1 .152-1.54c.317-.21.548-.367.794-.489a4 4 0 0 1 2.363-.369c.271.04.54.12.905.225l1.347.384L8.36 9.594 4.35 6.156a1 1 0 0 1 .203-1.653l.445-.223c.511-.255.952-.487 1.432-.567a3 3 0 0 1 1.185.04c.474.113.898.374 1.39.664l4.021 2.365zM7.02 12.751a1 1 0 0 1-.794.109l-1.767-.505c-.416-.12-.54-.152-.654-.17-.2-.03-.404-.028-.602.003l1.245 1.244c.694.693.847.82.988.878.163.067.343.09.518.065.15-.021.33-.105 1.174-.606l3.605-2.142-.776-.664zm5.527-2.201 1.463-.868L7.99 6.14c-.601-.354-.726-.415-.838-.442a1 1 0 0 0-.295-.025zm7.577-4.498a.96.96 0 0 0-1.293-.32l-3.824 2.214.967.57z",
  clipRule: "evenodd"
}));
export default SvgPlaneTakeoff;
//# sourceMappingURL=PlaneTakeoff.js.map